/* The locator script. Built by tools/build-assets.mjs from the review set; edit the review set, not this file. */
/* Dealer Locator. The live section's own script (teralumeindustries.com/pages/store-locator, captured 2026-09-18,
   frozen in src/web/live/dealer-locator.html), renamed to the ti-loc parts and the Playbook's wording:
   - the map is the brand's own drawing of the country (parts/map-drawing.html, as the home page draws it), with a pin where
     dealers are; nothing is loaded from a map host and no tile library is embedded (Dan, 6 October)
   - a postcode resolves on the page from the same table the dealer finder uses; a suburb matches the dealers' own;
     "Use your location" is the browser's own position
   - times read "8:30 am", ranges read "to"; no dash ranges
   - the theme editor's notes (pinned from the address, copy coordinates) are left to the theme section
   A dealer with coordinates is pinned; one without is listed and never pinned. A dealer outside Australia (its state not one of
   the eight: NZ) is listed last under its country, has no pin, is left out of a search by postcode or position and of the count:
   the map and the network the page counts are Australia's. */
(function () {
  var root = document.getElementById('ti-locator');
  if (!root) return;
  var ENQUIRE = '/pages/xgo-online-enquiry';
  var PAGES = '/pages/';
  var DEALERS = [];
  try { DEALERS = JSON.parse(root.querySelector('[data-loc-data]').textContent) || []; } catch (e) { return; }
  DEALERS = DEALERS.filter(function (d) { return d.name; });
  DEALERS.forEach(function (d) {
    var la = parseFloat(d.lat), ln = parseFloat(d.lng);
    if (isFinite(la) && isFinite(ln) && (la !== 0 || ln !== 0)) { d.lat = la; d.lng = ln; d._geo = 'set'; }
    else { d.lat = null; d.lng = null; d._geo = 'none'; }
  });
  var AU = { QLD: 1, NSW: 1, ACT: 1, VIC: 1, TAS: 1, SA: 1, WA: 1, NT: 1 };
  function inAu(d) { return !!AU[d.state]; }
  function placed(v) { return v !== null && v !== '' && isFinite(v); }
  var cfg = {
    cap: parseInt(root.dataset.listCap, 10) || 10,
    farKm: parseInt(root.dataset.farKm, 10) || 250
  };
  var q = function (s) { return root.querySelector(s); };
  var els = {
    map: q('[data-loc-map]'), q: q('[data-loc-q]'), field: q('[data-loc-field]'), clear: q('[data-loc-clear]'),
    suggest: q('[data-loc-suggest]'), geo: q('[data-loc-geo]'), cards: q('[data-loc-cards]'), count: q('[data-loc-count]'),
    more: q('[data-loc-more]'), empty: q('[data-loc-empty]'), detail: q('[data-loc-detail]'), list: q('[data-loc-list]'),
    status: q('[data-loc-status]'), reset: q('[data-loc-reset]'), side: q('[data-loc-side]'), scroll: q('[data-loc-scroll]'),
    bar: q('.ti-loc__bar'), body: q('.ti-loc__body')
  };
  var origin = null, selectedId = null, visible = [], shown = cfg.cap;
  var fig = els.map ? els.map.querySelector('.ti-map__fig') : null, pins = [], meDot = null;
  var WIDE = 1000;

  /* The search bar parks under the sticky header, and the map and the list under the search bar. Measure both (the header by
     its own class: the theme has no #xgo, and a phone's header is shorter than the stylesheet's 77 px). */
  function measureChrome() {
    var hdr = document.querySelector('.ti-hdr');
    if (hdr) root.style.setProperty('--hdr-h', Math.round(hdr.getBoundingClientRect().height) + 'px');
    if (els.bar) root.style.setProperty('--bar-h', Math.round(els.bar.getBoundingClientRect().height) + 'px');
  }
  measureChrome();
  window.addEventListener('load', measureChrome);
  if ('ResizeObserver' in window && els.bar) new ResizeObserver(measureChrome).observe(els.bar);

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function haversine(a, b) {
    var R = 6371, dLat = (b.lat - a.lat) * Math.PI / 180, dLng = (b.lng - a.lng) * Math.PI / 180;
    var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a.lat * Math.PI / 180) * Math.cos(b.lat * Math.PI / 180) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
  }
  function fmtKm(km) { return km < 10 ? km.toFixed(1) + ' km' : Math.round(km).toLocaleString('en-AU') + ' km'; }
  function telHref(p) { return 'tel:' + String(p || '').replace(/[^0-9+]/g, ''); }
  function hasGeo(d) { return d._geo === 'set'; }
  function addressText(d) { return [d.address, d.suburb, d.state, d.postcode].filter(Boolean).join(', '); }
  function addressLines(d) { return [d.address, [d.suburb, d.state, d.postcode].filter(Boolean).join(' ')].filter(Boolean); }
  /* Directions use the dealer's own map link when one is set: that pin is exactly where the dealer says it is. */
  function dirHref(d) {
    if (d.map_url) return d.map_url;
    return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(addressText(d) || d.name) + (hasGeo(d) ? '&travelmode=driving' : '');
  }
  function mapHref(d) {
    if (d.map_url) return d.map_url;
    return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(addressText(d) || d.name);
  }
  function isHQ(d) { return /hq|head office/i.test(d.type || ''); }

  /* ---------- a postcode to a place, on the page ----------
     The dealer finder's table (dealer-finder.js): a postcode range to a region-level centroid, good to roughly a suburb,
     which is all a "who is nearest" question needs. The two sides of a distance are always measured the same way. */
  var PC = [
    [1000,2079,-33.87,151.21],[2080,2099,-33.70,151.20],[2100,2249,-33.80,151.15],
    [2250,2263,-33.43,151.34],[2264,2310,-32.93,151.75],[2311,2339,-32.56,151.17],
    [2340,2411,-31.09,150.93],[2412,2499,-28.81,153.28],[2500,2534,-34.42,150.89],
    [2535,2551,-35.71,150.18],[2555,2574,-34.07,150.81],[2575,2594,-34.48,150.42],
    [2600,2619,-35.28,149.13],[2620,2639,-35.35,149.23],[2640,2649,-36.08,146.92],
    [2650,2659,-35.12,147.37],[2900,2914,-35.42,149.09],
    [2660,2699,-34.29,146.05],[2700,2739,-34.72,146.55],[2740,2786,-33.75,150.69],
    [2787,2799,-33.42,149.58],[2800,2879,-33.28,149.10],[2880,2899,-31.96,141.47],
    [3000,3210,-37.81,144.96],[3211,3334,-38.15,144.36],[3335,3399,-37.56,143.85],
    [3400,3489,-36.71,142.20],[3490,3549,-34.19,142.16],[3550,3599,-36.76,144.28],
    [3600,3649,-36.38,145.40],[3650,3699,-36.36,146.32],[3700,3749,-36.72,147.06],
    [3750,3810,-37.70,145.20],[3811,3899,-38.17,146.54],[3900,3999,-38.35,145.19],
    [4000,4207,-27.47,153.03],[4208,4287,-28.05,153.42],[4300,4339,-27.61,152.76],
    [4340,4499,-27.56,151.95],[4500,4519,-27.28,152.98],[4520,4557,-26.79,152.96],
    [4558,4579,-26.66,153.08],[4580,4659,-25.55,152.70],[4660,4679,-24.87,152.35],
    [4680,4699,-23.84,151.26],[4700,4739,-23.38,150.51],[4740,4769,-21.14,149.19],
    [4770,4869,-19.26,146.82],[4870,4899,-16.92,145.77],
    [5000,5199,-34.93,138.60],[5200,5299,-35.55,138.62],[5300,5499,-34.17,140.75],
    [5500,5599,-33.55,138.20],[5600,5699,-32.49,137.77],[5700,5799,-31.13,136.82],
    [6000,6199,-31.95,115.86],[6200,6299,-32.50,116.00],[6300,6399,-34.99,117.88],
    [6400,6429,-31.48,118.28],[6430,6449,-30.75,121.47],[6450,6499,-33.86,121.89],[6500,6599,-30.75,116.00],[6600,6699,-29.70,116.00],
    [6700,6799,-20.74,116.85],
    [7000,7199,-42.88,147.33],[7200,7299,-41.44,147.14],[7300,7499,-41.18,146.35],
    [800,869,-12.46,130.84],[870,899,-23.70,133.88]
  ];
  function pcAt(pc) {
    for (var i = 0; i < PC.length; i++) { if (pc >= PC[i][0] && pc <= PC[i][1]) return { lat: PC[i][2], lng: PC[i][3] }; }
    return null;
  }

  /* ---------- open or closed, in the DEALER's timezone. Daylight saving: first Sunday in October to first Sunday in April,
     in NSW, VIC, SA, TAS and the ACT. ---------- */
  var BASE_OFFSET = { QLD: 10, NSW: 10, VIC: 10, ACT: 10, TAS: 10, SA: 9.5, NT: 9.5, WA: 8, NZ: 12 };
  var DST_STATES = { NSW: 1, VIC: 1, ACT: 1, TAS: 1, SA: 1 };
  function firstSunday(y, m) { var d = new Date(Date.UTC(y, m, 1)); return 1 + ((7 - d.getUTCDay()) % 7); }
  function lastSunday(y, m) { var d = new Date(Date.UTC(y, m + 1, 0)); return d.getUTCDate() - d.getUTCDay(); }
  function inAuDst(u) {
    var y = u.getUTCFullYear(), m = u.getUTCMonth();
    if (m > 3 && m < 9) return false;
    if (m > 9 || m < 3) return true;
    if (m === 9) return u.getUTCDate() >= firstSunday(y, 9);
    if (m === 3) return u.getUTCDate() < firstSunday(y, 3);
    return false;
  }
  /* New Zealand's daylight saving: the last Sunday in September to the first Sunday in April */
  function inNzDst(u) {
    var y = u.getUTCFullYear(), m = u.getUTCMonth();
    if (m > 3 && m < 8) return false;
    if (m > 8 || m < 3) return true;
    if (m === 8) return u.getUTCDate() >= lastSunday(y, 8);
    if (m === 3) return u.getUTCDate() < firstSunday(y, 3);
    return false;
  }
  function localAt(state) {
    var now = new Date(), off = BASE_OFFSET[state] != null ? BASE_OFFSET[state] : 10;
    if (DST_STATES[state] && inAuDst(now)) off += 1;
    if (state === 'NZ' && inNzDst(now)) off += 1;
    return new Date(now.getTime() + now.getTimezoneOffset() * 60000 + off * 3600000);
  }
  var DAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var DAY_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  function hoursFor(d, i) {
    if (!d.hours) return '';
    var v = d.hours[DAY_KEYS[i]];
    if (!v && i >= 1 && i <= 5) v = d.hours.wd;
    return v || '';
  }
  function hasHours(d) { for (var i = 0; i < 7; i++) { if (hoursFor(d, i)) return true; } return false; }
  function splitSpan(span) { return String(span).split(/\s*[–—-]\s*/); }
  /* "08:30" reads "8:30 am", "17:00" reads "5 pm". Anything that is not a time is shown as it is. */
  function clock(t) {
    var m = /^\s*(\d{1,2}):(\d{2})\s*$/.exec(t);
    if (!m) return String(t).trim();
    var h = parseInt(m[1], 10), mm = m[2], ap = h >= 12 ? 'pm' : 'am', h12 = h % 12 === 0 ? 12 : h % 12;
    return h12 + (mm === '00' ? '' : ':' + mm) + ' ' + ap;
  }
  function spanText(span) {
    var p = splitSpan(span);
    return p.length === 2 && /\d/.test(p[0]) ? clock(p[0]) + ' to ' + clock(p[1]) : span;
  }
  function openState(d) {
    if (!hasHours(d)) return { open: false, hide: true, text: '' };
    var local = localAt(d.state), span = hoursFor(d, local.getDay());
    if (!span || /closed/i.test(span)) return { open: false, text: 'Closed today' };
    var p = splitSpan(span);
    if (p.length < 2) return { open: false, text: span };
    function mins(t) { var x = t.trim().split(':'); return parseInt(x[0], 10) * 60 + parseInt(x[1] || '0', 10); }
    var n = local.getHours() * 60 + local.getMinutes(), a = mins(p[0]), b = mins(p[1]);
    if (isNaN(a) || isNaN(b)) return { open: false, text: span };
    if (n >= a && n < b) return { open: true, text: 'Open now · until ' + clock(p[1]) };
    return { open: false, text: 'Closed · opens ' + clock(p[0]) };
  }

  /* ---------- the map: the drawing's pins ----------
     The drawing's projection (parts/map-drawing.html): x = (longitude - 112.6) cos 26 deg x 24 + 6 over 898,
     y = (-latitude - 10.2) x 24 + 6 over 815, as a share of the figure. Dealers within 30 km share one pin (the Sunshine
     Coast's two), as the home page's map pins a region. A pin sorts the list from where it is and opens its dealer, and the
     address carries its region (?region= the region page's handle), so the pick can be sent on; any other search clears it. */
  function project(lat, lng) {
    return { x: ((lng - 112.6) * 0.898794046 * 24 + 6) / 898 * 100, y: ((-lat - 10.2) * 24 + 6) / 815 * 100 };
  }
  function onMap(p) { return p.x > -2 && p.x < 102 && p.y > -2 && p.y < 102; }
  function groups() {
    var out = [];
    DEALERS.filter(hasGeo).forEach(function (d) {
      var g = null;
      for (var i = 0; i < out.length && !g; i++) { if (haversine(out[i], d) < 30) g = out[i]; }
      if (!g) { g = { lat: d.lat, lng: d.lng, dealers: [] }; out.push(g); }
      g.dealers.push(d);
      var n = g.dealers.length;
      g.lat = g.dealers.reduce(function (s, x) { return s + x.lat; }, 0) / n;
      g.lng = g.dealers.reduce(function (s, x) { return s + x.lng; }, 0) / n;
    });
    return out;
  }
  function drawPins() {
    if (!fig) return;
    [].forEach.call(fig.querySelectorAll('.ti-map__pin, .ti-map__me'), function (p) { p.remove(); });
    pins = [];
    groups().forEach(function (g) {
      var p = project(g.lat, g.lng), hq = g.dealers.some(isHQ), place = g.dealers[0].suburb || g.dealers[0].name;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ti-map__pin' + (hq ? ' ti-map__pin--hq' : '');
      b.style.left = p.x.toFixed(2) + '%'; b.style.top = p.y.toFixed(2) + '%'; b.style.setProperty('--d', Math.round(p.x * 14 + 300) + 'ms');
      b.setAttribute('aria-label', g.dealers.map(function (d) { return d.name + ', ' + d.suburb; }).join('; '));
      b.innerHTML = '<span class="ti-map__tip" aria-hidden="true"><b>' + esc(place) + '</b>' + g.dealers.map(function (d) { return esc(d.name); }).join('<br>') + '</span>';
      b.addEventListener('click', function () { pickPin(g); });
      b._group = g;
      fig.appendChild(b);
      pins.push(b);
    });
  }
  function pickPin(g) {
    setOrigin(g.lat, g.lng, g.dealers.length === 1 ? g.dealers[0].suburb : g.dealers.map(function (d) { return d.suburb; }).join(' and '), true);
    if (g.dealers.length === 1) select(g.dealers[0].id, true);
    addressRegion(g.dealers[0].region || '');
  }
  function addressRegion(r) {
    try {
      var u = new URL(window.location.href);
      if (r) u.searchParams.set('region', r);
      else if (u.searchParams.has('region')) u.searchParams.delete('region');
      else return;
      window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }
  function paintMarkers() {
    pins.forEach(function (b) {
      if (selectedId || origin) b.style.transitionDelay = '0ms';   /* the entrance's stagger is over once a pin is picked */
      b.classList.toggle('is-sel', b._group.dealers.some(function (d) { return d.id === selectedId; }));
    });
    if (fig) {
      if (origin && !origin.pin) {
        var p = project(origin.lat, origin.lng);
        if (onMap(p)) {
          if (!meDot) { meDot = document.createElement('span'); meDot.className = 'ti-map__me'; meDot.setAttribute('aria-hidden', 'true'); fig.appendChild(meDot); }
          meDot.style.left = p.x.toFixed(2) + '%'; meDot.style.top = p.y.toFixed(2) + '%';
        } else if (meDot) { meDot.remove(); meDot = null; }
      } else if (meDot) { meDot.remove(); meDot = null; }
    }
  }

  /* ---------- the list ---------- */
  function compute() {
    var list = DEALERS.slice();
    if (origin) {
      list = list.filter(inAu);   /* a search by postcode or position is Australia's */
      list.forEach(function (d) { d._km = hasGeo(d) ? haversine(origin, d) : null; });
      list.sort(function (a, b) {
        if ((a._km == null) !== (b._km == null)) return a._km == null ? 1 : -1;
        if (a._km == null) return 0;
        return a._km - b._km;
      });
    } else {
      list.forEach(function (d) { d._km = null; });
      list.sort(function (a, b) {
        if (isHQ(a) !== isHQ(b)) return isHQ(a) ? -1 : 1;
        if (inAu(a) !== inAu(b)) return inAu(a) ? -1 : 1;   /* a dealer outside Australia last, under its country */
        var s = String(a.state).localeCompare(String(b.state));
        return s !== 0 ? s : String(a.suburb).localeCompare(String(b.suburb));
      });
    }
    visible = list;
    return list;
  }
  var ICON_CALL = '<svg class="ti-i ti-i--phone" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2Z"/></svg>';   /* the library's phone (icons\phone.svg), drawn here because the card is written by this script */
  var ICON_PIN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 21s7-6.1 7-11a7 7 0 10-14 0c0 4.9 7 11 7 11z"/><circle cx="12" cy="10" r="2.6"/></svg>';
  var ICON_GO = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M4 10h11M11 5l5 5-5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';   /* the arrow of a link onward (.ti-more) */
  function badge(d) { return d.type ? '<span class="ti-loc__badge' + (isHQ(d) ? ' ti-loc__badge--hq' : '') + '">' + esc(d.type) + '</span>' : ''; }
  function cardHTML(d) {
    var st = openState(d), lines = addressLines(d);
    var addr = lines.length ? '<p class="ti-loc__meta"><a href="' + esc(mapHref(d)) + '" target="_blank" rel="noopener" data-stop>' + lines.map(esc).join('<br>') + '</a></p>' : '';
    return '<article class="ti-loc__card' + (d.id === selectedId ? ' is-selected' : '') + '" data-id="' + esc(d.id) + '" tabindex="0">' +
      '<div class="ti-loc__card-head"><div>' + badge(d) + '<h3>' + esc(d.name) + '</h3>' + addr +
        (st.hide ? '' : '<p class="ti-loc__open' + (st.open ? '' : ' is-shut') + '">' + esc(st.text) + '</p>') + '</div>' +
        (d._km != null ? '<div class="ti-loc__dist">' + fmtKm(d._km) + '<span>away</span></div>' : '') + '</div>' +
      (d.caps ? '<p class="ti-loc__caps">' + esc(d.caps) + '</p>' : '') +
      '<div class="ti-loc__acts">' +
        (d.phone ? '<a class="ti-btn ti-btn--primary" href="' + telHref(d.phone) + '" data-stop>' + ICON_CALL + 'Call</a>' : '') +
        '<a class="ti-btn ti-btn--outline" href="' + esc(dirHref(d)) + '" target="_blank" rel="noopener" data-stop>' + ICON_PIN + 'Get directions</a>' +
      '</div>' +
      '<button type="button" class="ti-loc__view" data-more="' + esc(d.id) + '">View dealer</button>' +
    '</article>';
  }
  function render() {
    var list = compute(), slice = list.slice(0, shown), html = '';
    if (!origin) {
      var last = '';
      slice.forEach(function (d) {
        if (d.state !== last) { html += '<p class="ti-label ti-loc__state">' + esc(d.state) + '</p>'; last = d.state; }
        html += cardHTML(d);
      });
    } else {
      html = slice.map(cardHTML).join('');
    }
    els.cards.innerHTML = html;
    var hidden = list.length - slice.length;
    els.more.hidden = hidden <= 0;
    els.more.textContent = hidden > 0 ? 'Show ' + hidden + ' more' : '';
    var nearest = list.filter(function (d) { return d._km != null; })[0];
    var far = origin && nearest && nearest._km > cfg.farKm;
    els.empty.classList.toggle('is-open', list.length === 0 || !!far);
    if (!list.length) els.count.textContent = 'No dealers to show.';
    else if (origin) els.count.textContent = list.length + ' location' + (list.length === 1 ? '' : 's') + ' · nearest to ' + origin.label;
    else els.count.textContent = list.filter(inAu).length + ' dealers · search or use your location to sort by distance';
    els.status.textContent = origin ? 'Nearest to ' + origin.label : DEALERS.filter(inAu).length + ' dealers, Australia-wide';
    els.reset.classList.toggle('is-on', !!origin);
    paintMarkers();
  }
  /* Runs of days that share the same hours are one line: "Mon to Fri", then the hours. */
  function hoursTable(d) {
    if (!hasHours(d)) return '';
    var order = [1, 2, 3, 4, 5, 6, 0], out = '', i = 0;
    while (i < order.length) {
      var val = hoursFor(d, order[i]) || 'Closed', j = i;
      while (j + 1 < order.length && (hoursFor(d, order[j + 1]) || 'Closed') === val) j++;
      var label = i === j ? DAY_NAMES[order[i]] : DAY_SHORT[order[i]] + ' to ' + DAY_SHORT[order[j]];
      out += '<b>' + esc(label) + '</b>' + esc(spanText(val)) + '<br>';
      i = j + 1;
    }
    return out;
  }
  function row(label, value) { return '<div class="ti-loc__row"><dt class="ti-label">' + label + '</dt><dd>' + value + '</dd></div>'; }
  function detailHTML(d) {
    var st = openState(d), rows = '', lines = addressLines(d);
    if (lines.length) rows += row('Address', '<a class="ti-loc__maplink" href="' + esc(mapHref(d)) + '" target="_blank" rel="noopener">' + lines.map(esc).join('<br>') + '</a>');
    if (d.phone) rows += row('Phone', '<a href="' + telHref(d.phone) + '">' + esc(d.phone) + '</a>');
    if (d.email) rows += row('Email', '<a href="mailto:' + esc(d.email) + '">' + esc(d.email) + '</a>');
    if (d.website) rows += row('Website', '<a href="' + esc(d.website) + '" target="_blank" rel="noopener">Visit site</a>');
    var h = hoursTable(d);
    if (h) rows += row('Hours', '<span class="ti-loc__hours">' + h + '</span>');
    return '<button type="button" class="ti-loc__back" data-back><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>All dealers</button>' +
      '<div class="ti-loc__detail-body">' + badge(d) + '<h3>' + esc(d.name) + '</h3>' +
        (st.hide && d._km == null ? '' : '<p class="ti-loc__open' + (st.open ? '' : ' is-shut') + '">' + (st.hide ? '' : esc(st.text)) + (d._km != null ? (st.hide ? '' : ' · ') + fmtKm(d._km) + ' away' : '') + '</p>') +
        (d.description ? '<p class="ti-loc__desc">' + esc(d.description) + '</p>' : '') +
        (d.caps ? '<p class="ti-loc__caps">' + esc(d.caps) + '</p>' : '') +
        '<dl class="ti-loc__rows">' + rows + '</dl>' +
        '<div class="ti-loc__acts">' +
          (d.phone ? '<a class="ti-btn ti-btn--primary" href="' + telHref(d.phone) + '">' + ICON_CALL + 'Call</a>' : '') +
          '<a class="ti-btn ti-btn--outline" href="' + esc(dirHref(d)) + '" target="_blank" rel="noopener">' + ICON_PIN + 'Get directions</a>' +
          '<a class="ti-btn ti-btn--outline ti-loc__full" href="' + ENQUIRE + '">Enquire about a build</a>' +
        '</div>' +
        (d.region && d.region_name ? '<a class="ti-loc__region" href="' + esc(PAGES + d.region) + '">Fitted in ' + esc(d.region_name) + ICON_GO + '</a>' : '') +
      '</div>';
  }
  function select(id, fromMap) {
    var d = DEALERS.filter(function (x) { return x.id === id; })[0];
    if (!d) return;
    selectedId = id;
    els.detail.innerHTML = detailHTML(d);
    els.detail.classList.add('is-open');
    els.list.style.display = 'none';
    els.scroll.scrollTop = 0;
    els.detail.querySelector('[data-back]').addEventListener('click', deselect);
    paintMarkers();
    if (window.innerWidth < WIDE && fromMap) setTimeout(function () { els.side.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 120);
  }
  function deselect() {
    selectedId = null;
    els.detail.classList.remove('is-open');
    els.detail.innerHTML = '';
    els.list.style.display = '';
    paintMarkers();
  }
  els.cards.addEventListener('click', function (e) {
    if (e.target.closest('[data-stop]')) return;
    var more = e.target.closest('[data-more]'), card = e.target.closest('.ti-loc__card');
    if (more) return select(more.getAttribute('data-more'));
    if (card) select(card.getAttribute('data-id'));
  });
  els.cards.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var card = e.target.closest('.ti-loc__card');
    if (card) { e.preventDefault(); select(card.getAttribute('data-id')); }
  });
  els.more.addEventListener('click', function () { shown += cfg.cap; render(); });
  els.reset.addEventListener('click', function () {
    origin = null; shown = cfg.cap;
    els.q.value = ''; els.field.classList.remove('is-filled');
    deselect(); render();
    addressRegion('');
  });

  /* ---------- search: a dealer's name, suburb or postcode, or any postcode, resolved on the page ---------- */
  var tId = null;
  els.q.addEventListener('input', function () {
    els.field.classList.toggle('is-filled', !!els.q.value);
    clearTimeout(tId);
    var v = els.q.value.trim();
    if (v.length < 2) { els.suggest.classList.remove('is-open'); return; }
    tId = setTimeout(function () { suggestFor(v); }, 180);
  });
  els.clear.addEventListener('click', function () {
    els.q.value = ''; els.field.classList.remove('is-filled');
    els.suggest.classList.remove('is-open'); els.q.focus();
  });
  function rowsFor(v) {
    var lower = v.toLowerCase(), rows = [];
    DEALERS.filter(function (d) {
      return (d.name + ' ' + d.address + ' ' + d.suburb + ' ' + d.postcode + ' ' + d.state).toLowerCase().indexOf(lower) !== -1;
    }).slice(0, 4).forEach(function (d) {
      rows.push({ label: d.name, sub: [d.suburb, d.state, d.postcode].filter(Boolean).join(' '), lat: d.lat, lng: d.lng, id: d.id });
    });
    var pc = /^\d{4}$/.test(v) ? pcAt(parseInt(v, 10)) : null;
    if (pc) rows.unshift({ label: 'Postcode ' + v, sub: 'The dealers closest to it', lat: pc.lat, lng: pc.lng, postcode: v });   /* a postcode typed is the place meant, before a dealer whose postcode matches */
    return rows;
  }
  function suggestFor(v) { paintSuggest(rowsFor(v)); }
  function paintSuggest(rows) {
    if (!rows.length) { els.suggest.classList.remove('is-open'); return; }
    els.suggest.innerHTML = rows.map(function (r, i) {
      return '<button type="button" data-i="' + i + '">' + esc(r.label) + '<span>' + esc(r.sub) + '</span></button>';
    }).join('');
    els.suggest._rows = rows;
    els.suggest.classList.add('is-open');
  }
  function take(r) {
    els.q.value = r.postcode || r.label;
    els.suggest.classList.remove('is-open');
    if (placed(r.lat) && placed(r.lng)) setOrigin(r.lat, r.lng, r.postcode || r.label, !!r.id);
    if (r.id) select(r.id);   /* a dealer with no pin opens where it is listed */
  }
  els.suggest.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    take(els.suggest._rows[parseInt(b.getAttribute('data-i'), 10)]);
  });
  els.q.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    var rows = els.suggest._rows && els.suggest.classList.contains('is-open') ? els.suggest._rows : rowsFor(els.q.value.trim());
    if (rows && rows.length && (placed(rows[0].lat) || rows[0].id)) take(rows[0]);
    else els.status.textContent = 'No match. Try a postcode, or a dealer’s suburb.';
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('[data-loc-field]')) els.suggest.classList.remove('is-open'); });
  function setOrigin(lat, lng, label, pin) {
    origin = { lat: lat, lng: lng, label: label, pin: !!pin };
    shown = cfg.cap;
    deselect(); render();
    addressRegion('');   /* a pin's pick writes its own region straight after */
  }
  /* A link from another page can carry a postcode (?postcode=4500): sort by distance and open the nearest dealer. */
  function handleIncomingPostcode() {
    var postcode = '';
    try { postcode = new URLSearchParams(window.location.search).get('postcode') || ''; } catch (e) {}
    postcode = String(postcode).replace(/\D/g, '').slice(0, 4);
    if (!/^\d{4}$/.test(postcode)) return;
    els.q.value = postcode;
    els.field.classList.add('is-filled');
    var pc = pcAt(parseInt(postcode, 10));
    if (!pc) { els.status.textContent = 'Couldn’t place that postcode. Search a suburb or postcode below.'; return; }
    setOrigin(pc.lat, pc.lng, postcode);
    var nearest = compute().filter(hasGeo)[0];
    if (nearest) select(nearest.id);
  }
  /* A pin on any other drawn map links here with its region (?region=fitted-in-mackay): that region's pin is picked as if it
     were clicked here, and the page opens on the map and the list, the head scrolled past (on a phone, the list under the
     search bar). Where both are given, the region wins over a postcode. */
  function handleIncomingRegion() {
    var r = '';
    try { r = new URLSearchParams(window.location.search).get('region') || ''; } catch (e) {}
    if (!r) return false;
    var g = (pins.length ? pins.map(function (b) { return b._group; }) : groups()).filter(function (x) {
      return x.dealers.some(function (d) { return d.region === r; });
    })[0];
    if (!g) return false;
    pickPin(g);
    arrive();
    if (document.readyState !== 'complete') window.addEventListener('load', arrive);
    return true;
  }
  function arrive() {
    var el = window.innerWidth < WIDE ? els.side : els.body;
    if (el) el.scrollIntoView({ block: 'start', behavior: 'instant' });   /* an arrival, not a move: never animated */
  }
  els.geo.addEventListener('click', function () {
    if (!navigator.geolocation) { els.status.textContent = 'Location not available on this device.'; return; }
    els.status.textContent = 'Finding you';
    navigator.geolocation.getCurrentPosition(function (pos) {
      els.q.value = ''; els.field.classList.remove('is-filled');
      setOrigin(pos.coords.latitude, pos.coords.longitude, 'your location');
    }, function () {
      els.status.textContent = 'Couldn’t get your location. Search a suburb or postcode instead.';
    }, { enableHighAccuracy: true, timeout: 8000 });
  });
  var rId = null;
  window.addEventListener('resize', function () {
    clearTimeout(rId);
    rId = setTimeout(measureChrome, 120);
  });
  drawPins();
  render();
  if (!handleIncomingRegion()) handleIncomingPostcode();
})();
